module.exports = __webpack_public_path__ + "static/img/03.6dd66f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/mz_brunegg/03.jpg
// module id = 425
// module chunks = 1